import type { LiveSource, ScheduleItem } from '../types/index.js'

/**
 * Flux vers lesquels un direct à l'antenne peut basculer. Miroir d'affichage
 * de `backend/src/lib/live-source-switch.ts` : le serveur reste seul juge.
 * Seulement un flux Internet actif de la chaîne, autre que le flux en cours —
 * une entrée DeckLink ne dit pas quand son image arrive.
 */
export function liveSourceSwitchCandidates(sources: readonly LiveSource[], item: Pick<ScheduleItem, 'liveSourceId'>, channelId: string): LiveSource[] {
  return sources
    .filter(source => (
      source.channelId === channelId
      && source.active
      && source.sourceType !== 'DECKLINK'
      && Boolean(source.connectionString?.trim())
      && source.id !== item.liveSourceId
    ))
    .sort((a, b) => a.name.localeCompare(b.name, 'fr'))
}

/** Le direct peut-il changer de flux depuis la régie ou la grille ? */
export function canSwitchLiveSource(item: Pick<ScheduleItem, 'itemType' | 'status'>): boolean {
  return item.itemType === 'LIVE' && item.status === 'ON_AIR'
}
